import $ from 'jquery'
import { hashHistory } from 'react-router'
import { barcodeScanned } from './actions/barcodeActions'

export function startScanner(store) {
    const minimumBarcodeLength = 5;
    const ejectorSeatChar = 33;
    const carriageReturnChar = 13;

    var lastTimeout;

    // Variable to keep the barcode when scanned. When we scan each
    // character is a keypress and hence we push it onto the array.
    var chars = [];

    const checkBuffer = buffer => {
        // If the virtual keyboard is shown it is not desired that barcodes could be triggered
        var keyboardIsVisible = store.getState().layoutState.keyboard.show;
        if (buffer.length >= minimumBarcodeLength && !keyboardIsVisible) {
            // join the chars array to make a string of the barcode scanned
            const barcode = buffer.join("");
            store.dispatch(barcodeScanned(barcode));
            return true;
        }
        else {
            return false;
        }
    }

    // trigger an event on any keypress on this webpage
    $(window).keypress(function (e) {

        if (e.keyCode === ejectorSeatChar) {
            hashHistory.push('/clear');
        }

        chars.push(String.fromCharCode(e.which));

        // a carriage return is never a part of a barcode, so if we encounter one, we can check if we have a 
        // barcode in the buffer immediately.
        // note that we do not remove the carriage return. we assume it is handled server side by the filter
        if (e.keyCode === carriageReturnChar && checkBuffer(chars)) {
            chars = [];
        }
        else {
            if (lastTimeout) {
                clearTimeout(lastTimeout);
            }

            lastTimeout = setTimeout(function () {
                // check we have a long length e.g. it is a barcode
                checkBuffer(chars);
                chars = [];
            }, 100);
        }
    });
}



// WEBPACK FOOTER //
// src/scanner.js